import type {SalesRepository} from '../repository/SalesRepository';
import type {Sale} from '../models/sale.model';
import type {UpdateSaleRequestDTO} from '../models/sale.dto';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class UpdateSaleUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (id: string, saleData: UpdateSaleRequestDTO): Promise<BaseResponse<Sale>> {
    return this.salesRepository.updateSale(id, saleData);
  }
}
